// extracted by mini-css-extract-plugin
module.exports = {"scrollToBottomBtn":"ScrollButton_scrollToBottomBtn__3X5oy","hideButton":"ScrollButton_hideButton__3ATdj"};